// extracted by mini-css-extract-plugin
export default {"page__container":"visuals_page__container__h5Zfc"};